import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { InstantReportsConfigInfoController } from '../../models/report/report.model';


@Pipe({
  name: 'InstantReportsConfigFilter'
})

@Injectable()
export class InstantReportsConfigPipe implements PipeTransform {

  transform(value: InstantReportsConfigInfoController[], filter: string): InstantReportsConfigInfoController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: InstantReportsConfigInfoController) =>
      app.FriendlyName != null && app.FriendlyName.toLocaleLowerCase().indexOf(filter) != -1

      || app.ReportType != null && app.ReportType.toLocaleLowerCase().indexOf(filter) != -1
    ) : value;
  }

}
